export const ACTIVE_BLOCK_CLASS = 'active-block';
